// src/i18n.js

export const supportedLangs = ['en', 'ru', 'zh', 'es', 'de', 'fr', 'ja', 'hi', 'pt', 'ko', 'it', 'kk'];
export const defaultLang = 'en';

const translations = {
  // ===== NAV =====
  'nav.features': {
    en: 'Features',
    ru: 'Функции',
    zh: '功能',
    es: 'Funciones',
    de: 'Funktionen',
    fr: 'Fonctionnalités',
    ja: '機能',
    hi: 'फ़ीचर्स',
    pt: 'Funcionalidades',
    ko: '기능',
    it: 'Funzionalità',
    kk: 'Мүмкіндіктер',
  },
  'nav.workflow': {
    en: 'How it works',
    ru: 'Как это работает',
    zh: '如何运作',
    es: 'Cómo funciona',
    de: 'Wie es funktioniert',
    fr: 'Comment ça marche',
    ja: '使い方',
    hi: 'यह कैसे काम करता है',
    pt: 'Como funciona',
    ko: '작동 방식',
    it: 'Come funziona',
    kk: 'Қалай жұмыс істейді',
  },
  'nav.pricing': {
    en: 'Pricing',
    ru: 'Тарифы',
    zh: '价格',
    es: 'Precios',
    de: 'Preise',
    fr: 'Tarifs',
    ja: '料金',
    hi: 'कीमतें',
    pt: 'Preços',
    ko: '요금제',
    it: 'Prezzi',
    kk: 'Тарифтер',
  },
  'nav.faq': {
    en: 'FAQ',
    ru: 'FAQ',
    zh: '常见问题',
    es: 'Preguntas frecuentes',
    de: 'FAQ',
    fr: 'FAQ',
    ja: 'よくある質問',
    hi: 'अक्सर पूछे जाने वाले प्रश्न',
    pt: 'FAQ',
    ko: 'FAQ',
    it: 'FAQ',
    kk: 'Жиі қойылатын сұрақтар',
  },
  'nav.login': {
    en: 'Log in',
    ru: 'Войти',
    zh: '登录',
    es: 'Iniciar sesión',
    de: 'Anmelden',
    fr: 'Se connecter',
    ja: 'ログイン',
    hi: 'लॉग इन',
    pt: 'Entrar',
    ko: '로그인',
    it: 'Accedi',
    kk: 'Кіру',
  },

  // пример из тебя — оставляем
  'nav.profile': {
    en: 'Profile',
    zh: '个人资料',
    es: 'Perfil',
    ru: 'Профиль',
    de: 'Profil',
    fr: 'Profil',
    ja: 'プロフィール',
    hi: 'प्रोफ़ाइल',
    pt: 'Perfil',
    ko: '프로필',
    it: 'Profilo',
    kk: 'Профиль',
  },

  // ===== HERO =====
  'hero.badge': {
    en: 'Next-level planner',
    ru: 'Новый уровень планирования',
    zh: '新一代日程规划',
    es: 'Planificador de siguiente nivel',
    de: 'Planer der nächsten Stufe',
    fr: 'Planificateur nouvelle génération',
    ja: '次世代プランナー',
    hi: 'नेक्स्ट-लेवल प्लानर',
    pt: 'Planejador de próximo nível',
    ko: '다음 단계의 플래너',
    it: 'Planner di nuova generazione',
    kk: 'Келесі деңгейдегі жоспарлаушы',
  },
  'hero.title.part1': {
    en: 'Bring order to your tasks',
    ru: 'Наведи порядок в задачах',
    zh: '让任务井然有序',
    es: 'Pon orden en tus tareas',
    de: 'Bringe Ordnung in deine Aufgaben',
    fr: 'Mettez de l’ordre dans vos tâches',
    ja: 'タスクを整えよう',
    hi: 'अपनी टास्क में व्यवस्था लाएँ',
    pt: 'Coloque ordem nas suas tarefas',
    ko: '할 일을 정돈하세요',
    it: 'Metti ordine nelle tue attività',
    kk: 'Тапсырмаларыңды ретке келтір',
  },
  'hero.title.accent': {
    en: 'effortlessly',
    ru: 'без лишних усилий',
    zh: '轻松地',
    es: 'sin esfuerzo',
    de: 'mühelos',
    fr: 'sans effort',
    ja: '手間なく',
    hi: 'बिना मेहनत के',
    pt: 'sem esforço',
    ko: '쉽게',
    it: 'senza sforzo',
    kk: 'оңай',
  },

  'hero.subtitle': {
    en: 'A light yet powerful TODO app that stays out of your way but helps you finish what matters every day.',
    ru: 'Лёгкое и мощное TODO-приложение, которое не мешает, но помогает доводить важное до конца каждый день.',
    zh: '轻量但强大的待办应用，不打扰你，却每天帮你完成真正重要的事。',
    es: 'Una app de tareas ligera pero potente, que no estorba y te ayuda a terminar lo importante cada día.',
    de: 'Eine leichte, aber leistungsstarke To-do-App, die dich nicht stört und dir hilft, jeden Tag das Wichtige zu erledigen.',
    fr: 'Une app de tâches légère mais puissante, qui ne vous gêne pas et vous aide à terminer l’essentiel chaque jour.',
    ja: '軽量でパワフルなTODOアプリ。邪魔をせず、毎日大事なことをやり切るのを助けます。',
    hi: 'हल्की लेकिन शक्तिशाली TODO ऐप, जो रास्ते में नहीं आती पर रोज़ ज़रूरी काम पूरे कराने में मदद करती है।',
    pt: 'Um app de tarefas leve, mas poderoso, que não atrapalha e ajuda você a concluir o que importa todos os dias.',
    ko: '가볍지만 강력한 TODO 앱으로 방해받지 않고, 매일 중요한 일을 끝낼 수 있습니다.',
    it: 'Un’app TODO leggera ma potente che non ti intralcia e ti aiuta a portare a termine ciò che conta ogni giorno.',
    kk: 'Жеңіл әрі қуатты TODO-қосымша: кедергі келтірмей, күн сайын маңызды істерді аяқтауға көмектеседі.',
  },

  'hero.secondaryCta': {
    en: 'See interface',
    ru: 'Посмотреть интерфейс',
    zh: '查看界面',
    es: 'Ver interfaz',
    de: 'Oberfläche ansehen',
    fr: 'Voir l’interface',
    ja: 'インターフェースを見る',
    hi: 'इंटरफ़ेस देखें',
    pt: 'Ver interface',
    ko: '인터페이스 보기',
    it: "Guarda l'interfaccia",
    kk: 'Интерфейсті көру',
  },

  'hero.meta.languages.value': {
    en: '12',
    ru: '12',
    zh: '12',
    es: '12',
    de: '12',
    fr: '12',
    ja: '12',
    hi: '12',
    pt: '12',
    ko: '12',
    it: '12',
    kk: '12',
  },
  'hero.meta.languages.label': {
    en: 'supported languages',
    ru: 'поддерживаемых языков',
    zh: '支持的语言',
    es: 'idiomas soportados',
    de: 'unterstützte Sprachen',
    fr: 'langues prises en charge',
    ja: '対応言語',
    hi: 'समर्थित भाषाएँ',
    pt: 'idiomas suportados',
    ko: '지원 언어',
    it: 'lingue supportate',
    kk: 'қолдау көрсетілетін тілдер',
  },
  'hero.meta.clicks.value': {
    en: '0',
    ru: '0',
    zh: '0',
    es: '0',
    de: '0',
    fr: '0',
    ja: '0',
    hi: '0',
    pt: '0',
    ko: '0',
    it: '0',
    kk: '0',
  },
  'hero.meta.clicks.label': {
    en: 'extra clicks',
    ru: 'лишних кликов',
    zh: '多余点击',
    es: 'clics extra',
    de: 'zusätzliche Klicks',
    fr: 'clics en trop',
    ja: '余計なクリック',
    hi: 'फालतू क्लिक',
    pt: 'cliques extras',
    ko: '불필요한 클릭',
    it: 'clic extra',
    kk: 'артық шерту',
  },
  'hero.meta.reminders.value': {
    en: '24/7',
    ru: '24/7',
    zh: '24/7',
    es: '24/7',
    de: '24/7',
    fr: '24/7',
    ja: '24時間',
    hi: '24/7',
    pt: '24/7',
    ko: '24/7',
    it: '24/7',
    kk: '24/7',
  },
  'hero.meta.reminders.label': {
    en: 'reminders & push',
    ru: 'напоминания и пуши',
    zh: '提醒与推送',
    es: 'recordatorios y notificaciones',
    de: 'Erinnerungen & Push',
    fr: 'rappels et notifications',
    ja: 'リマインダーとプッシュ',
    hi: 'रिमाइंडर और पुश',
    pt: 'lembretes e push',
    ko: '알림 및 푸시',
    it: 'promemoria e push',
    kk: 'еске салғыштар мен push-хабарламалар',
  },

  // HERO CARD
  'hero.card.todayChip': {
    en: 'Today',
    ru: 'Сегодня',
    zh: '今天',
    es: 'Hoy',
    de: 'Heute',
    fr: 'Aujourd’hui',
    ja: '今日',
    hi: 'आज',
    pt: 'Hoje',
    ko: '오늘',
    it: 'Oggi',
    kk: 'Бүгін',
  },
  'hero.card.focusChip': {
    en: 'Focus',
    ru: 'Фокус',
    zh: '专注',
    es: 'Enfoque',
    de: 'Fokus',
    fr: 'Focus',
    ja: 'フォーカス',
    hi: 'फ़ोकस',
    pt: 'Foco',
    ko: '포커스',
    it: 'Focus',
    kk: 'Фокус',
  },
  'hero.card.task1.title': {
    en: 'Build daily plan',
    ru: 'Собрать ежедневный план',
    zh: '制定每日计划',
    es: 'Crear plan diario',
    de: 'Tagesplan erstellen',
    fr: 'Construire le plan du jour',
    ja: '1日のプランを立てる',
    hi: 'डेली प्लान बनाएं',
    pt: 'Montar plano diário',
    ko: '하루 계획 세우기',
    it: 'Crea il piano giornaliero',
    kk: 'Күндік жоспар құру',
  },
  'hero.card.task1.meta': {
    en: '09:00 • High priority',
    ru: '09:00 • Высокий приоритет',
    zh: '09:00 • 高优先级',
    es: '09:00 • Alta prioridad',
    de: '09:00 • Hohe Priorität',
    fr: '09:00 • Haute priorité',
    ja: '09:00 • 高優先度',
    hi: '09:00 • उच्च प्राथमिकता',
    pt: '09:00 • Alta prioridade',
    ko: '09:00 • 높은 우선순위',
    it: '09:00 • Alta priorità',
    kk: '09:00 • Жоғары басымдық',
  },
  'hero.card.task1.badge': {
    en: '#focus',
    ru: '#фокус',
    zh: '#专注',
    es: '#foco',
    de: '#fokus',
    fr: '#focus',
    ja: '#フォーカス',
    hi: '#फोकस',
    pt: '#foco',
    ko: '#포커스',
    it: '#focus',
    kk: '#фокус',
  },

  'hero.card.task2.title': {
    en: 'Inbox zero: email',
    ru: 'Разобрать почту',
    zh: '清空邮箱',
    es: 'Bandeja cero: correos',
    de: 'Inbox Zero: E-Mails',
    fr: 'Inbox zéro : emails',
    ja: '受信トレイゼロ: メール',
    hi: 'इनबॉक्स ज़ीरो: ईमेल',
    pt: 'Inbox zero: e-mail',
    ko: '인박스 제로: 이메일',
    it: 'Inbox zero: email',
    kk: 'Inbox zero: пошта',
  },
  'hero.card.task2.meta': {
    en: '11:30 • 32 emails',
    ru: '11:30 • 32 письма',
    zh: '11:30 • 32 封邮件',
    es: '11:30 • 32 correos',
    de: '11:30 • 32 E-Mails',
    fr: '11:30 • 32 emails',
    ja: '11:30 • 32通のメール',
    hi: '11:30 • 32 ईमेल',
    pt: '11:30 • 32 emails',
    ko: '11:30 • 이메일 32개',
    it: '11:30 • 32 email',
    kk: '11:30 • 32 хат',
  },
  'hero.card.task2.badge': {
    en: 'before lunch',
    ru: 'до обеда',
    zh: '午饭前',
    es: 'antes de comer',
    de: 'vor dem Mittagessen',
    fr: 'avant le déjeuner',
    ja: 'ランチ前',
    hi: 'लंच से पहले',
    pt: 'antes do almoço',
    ko: '점심 전에',
    it: 'prima di pranzo',
    kk: 'түскіге дейін',
  },

  'hero.card.task3.title': {
    en: 'Workout',
    ru: 'Тренировка',
    zh: '锻炼',
    es: 'Entrenamiento',
    de: 'Workout',
    fr: 'Entraînement',
    ja: 'トレーニング',
    hi: 'वर्कआउट',
    pt: 'Treino',
    ko: '운동',
    it: 'Allenamento',
    kk: 'Жаттығу',
  },
  'hero.card.task3.meta': {
    en: '18:00 • habit',
    ru: '18:00 • привычка',
    zh: '18:00 • 习惯',
    es: '18:00 • hábito',
    de: '18:00 • Gewohnheit',
    fr: '18:00 • habitude',
    ja: '18:00 • 習慣',
    hi: '18:00 • आदत',
    pt: '18:00 • hábito',
    ko: '18:00 • 습관',
    it: '18:00 • abitudine',
    kk: '18:00 • әдет',
  },
  'hero.card.task3.badge': {
    en: 'repeat',
    ru: 'повтор',
    zh: '重复',
    es: 'repetición',
    de: 'Wiederholung',
    fr: 'répétition',
    ja: 'リピート',
    hi: 'दोहराएँ',
    pt: 'repetir',
    ko: '반복',
    it: 'ripeti',
    kk: 'қайталау',
  },
  'hero.card.progressLabel': {
    en: 'Completed 3 of 5 tasks',
    ru: 'Выполнено 3 из 5 задач',
    zh: '已完成 5 个任务中的 3 个',
    es: 'Completadas 3 de 5 tareas',
    de: '3 von 5 Aufgaben erledigt',
    fr: '3 tâches sur 5 terminées',
    ja: '5タスク中3件完了',
    hi: '5 में से 3 टास्क पूरी',
    pt: '3 de 5 tarefas concluídas',
    ko: '5개 중 3개 작업 완료',
    it: 'Completate 3 attività su 5',
    kk: '5 тапсырманың 3-і орындалды',
  },

  // ===== FEATURES =====
  'features.title': {
    en: 'What Plannely can do',
    ru: 'Что умеет Plannely',
    zh: 'Plannely 能做什么',
    es: 'Qué puede hacer Plannely',
    de: 'Was Plannely kann',
    fr: 'Ce que Plannely peut faire',
    ja: 'Plannely でできること',
    hi: 'Plannely क्या कर सकता है',
    pt: 'O que o Plannely pode fazer',
    ko: 'Plannely로 할 수 있는 것',
    it: 'Cosa può fare Plannely',
    kk: 'Plannely не істей алады',
  },
  'features.subtitle': {
    en: 'Only the features you actually need, without noise and clutter.',
    ru: 'Только нужные функции, без шума и перегруза.',
    zh: '只提供你真正需要的功能，没有多余的复杂度。',
    es: 'Solo las funciones que realmente necesitas, sin ruido y desorden.',
    de: 'Nur die Funktionen, die du wirklich brauchst – ohne Ballast.',
    fr: 'Uniquement les fonctions dont vous avez besoin, sans surcharge.',
    ja: '本当に必要な機能だけ。ノイズやごちゃごちゃはなし。',
    hi: 'सिर्फ वही फ़ीचर्स जो सच में ज़रूरी हैं, बिना बेकार की भीड़भाड़ के।',
    pt: 'Apenas os recursos que você realmente precisa, sem ruído nem confusão.',
    ko: '정말 필요한 기능만, 복잡함과 잡음을 빼고 담았습니다.',
    it: 'Solo le funzioni di cui hai davvero bisogno, senza rumore e confusione.',
    kk: 'Шынымен қажет мүмкіндіктер ғана, артық шу мен күрделіліксіз.',
  },

  'features.fastAdd.title': {
    en: 'Instant add',
    ru: 'Мгновенное добавление',
    zh: '快速添加',
    es: 'Añadido instantáneo',
    de: 'Sofortiges Hinzufügen',
    fr: 'Ajout instantané',
    ja: '即時追加',
    hi: 'तुरंत जोड़ें',
    pt: 'Adição instantânea',
    ko: '즉시 추가',
    it: 'Aggiunta istantanea',
    kk: 'Лезде қосу',
  },
  'features.fastAdd.text': {
    en: 'Create tasks in two taps: title, time — done. The app takes care of the rest.',
    ru: 'Создавай задачи в два тапа: название, время — готово. Остальное приложение сделает за тебя.',
    zh: '两步创建任务：标题、时间——完成，其余交给应用处理。',
    es: 'Crea tareas en dos toques: título, hora — listo. La app se encarga del resto.',
    de: 'Erstelle Aufgaben in zwei Taps: Titel, Zeit – fertig. Den Rest übernimmt die App.',
    fr: 'Créez vos tâches en deux gestes : titre, heure — c’est fait. L’app s’occupe du reste.',
    ja: '2タップでタスク作成：タイトルと時間だけ。あとはアプリにお任せ。',
    hi: 'दो टैप में टास्क बनाओ: टाइटल, समय — हो गया। बाकी ऐप संभालेगा।',
    pt: 'Crie tarefas em dois toques: título, hora — pronto. O app cuida do resto.',
    ko: '두 번의 탭으로 작업을 만드세요: 제목, 시간 — 끝. 나머지는 앱이 처리합니다.',
    it: 'Crea attività in due tocchi: titolo, orario — fatto. Il resto lo gestisce l’app.',
    kk: 'Екі қадамда тапсырма жаса: атауы, уақыты — дайын. Қалғанын қосымша өзі орындайды.',
  },

  'features.reminders.title': {
    en: 'Smart reminders',
    ru: 'Умные напоминания',
    zh: '智能提醒',
    es: 'Recordatorios inteligentes',
    de: 'Intelligente Erinnerungen',
    fr: 'Rappels intelligents',
    ja: 'スマートリマインダー',
    hi: 'स्मार्ट रिमाइंडर',
    pt: 'Lembretes inteligentes',
    ko: '스마트 알림',
    it: 'Promemoria intelligenti',
    kk: 'Ақылды еске салғыштар',
  },
  'features.reminders.text': {
    en: 'Reliable push notifications and repeats. No missed deadlines.',
    ru: 'Надёжные пуши и повторения. Никаких пропущенных дедлайнов.',
    zh: '可靠的推送与重复提醒，不再错过截止时间。',
    es: 'Notificaciones fiables y repeticiones. Nada de plazos perdidos.',
    de: 'Zuverlässige Pushes und Wiederholungen. Keine verpassten Deadlines.',
    fr: 'Notifications fiables et répétitions. Aucun délai manqué.',
    ja: '信頼できるプッシュと繰り返し。締切を逃しません。',
    hi: 'भरोसेमंद पुश और रिपीट। कोई डेडलाइन मिस नहीं।',
    pt: 'Notificações push confiáveis e repetições. Nada de prazos perdidos.',
    ko: '신뢰할 수 있는 푸시 알림과 반복 설정. 마감 기한을 놓치지 마세요.',
    it: 'Notifiche push affidabili e ripetizioni. Nessuna scadenza mancata.',
    kk: 'Сенімді push-хабарламалар мен қайталаулар. Дедлайндарды өткізіп алмаңыз.',
  },

  'features.calendar.title': {
    en: 'Calendar & timeline',
    ru: 'Календарь и таймлайн',
    zh: '日历与时间线',
    es: 'Calendario y línea de tiempo',
    de: 'Kalender & Timeline',
    fr: 'Calendrier & chronologie',
    ja: 'カレンダーとタイムライン',
    hi: 'कैलेंडर और टाइमलाइन',
    pt: 'Calendário e cronograma',
    ko: '캘린더 & 타임라인',
    it: 'Calendario e timeline',
    kk: 'Күнтізбе және таймлайн',
  },
  'features.calendar.text': {
    en: 'View day, week, month and year. Tasks and habits in one clean timeline.',
    ru: 'Смотри день, неделю, месяц и год. Задачи и привычки в одном аккуратном таймлайне.',
    zh: '按日、周、月、年查看，一条干净的时间线上看到任务与习惯。',
    es: 'Ve tu día, semana, mes y año. Tareas y hábitos en una sola línea de tiempo limpia.',
    de: 'Tag, Woche, Monat und Jahr im Blick. Aufgaben und Gewohnheiten in einer klaren Timeline.',
    fr: 'Jour, semaine, mois et année. Tâches et habitudes sur une seule chronologie claire.',
    ja: '日・週・月・年ビュー。タスクと習慣をひとつのきれいなタイムラインで。',
    hi: 'दिन, हफ़्ता, महीना और साल देखें। टास्क और हैबिट एक ही साफ़ टाइमलाइन पर।',
    pt: 'Veja dia, semana, mês e ano. Tarefas e hábitos em uma linha do tempo limpa.',
    ko: '하루, 주, 달, 연 단위 보기. 작업과 습관을 한 타임라인에 정리합니다.',
    it: 'Vista giorno, settimana, mese e anno. Attività e abitudini in un’unica timeline pulita.',
    kk: 'Күн, апта, ай және жыл бойынша қара. Тапсырмалар мен әдеттер бір таймлайнда.',
  },

  'features.locale.title': {
    en: 'Multi-language',
    ru: 'Мультиязычность',
    zh: '多语言',
    es: 'Multi-idioma',
    de: 'Mehrsprachig',
    fr: 'Multi-langue',
    ja: '多言語対応',
    hi: 'मल्टी-लैंग्वेज',
    pt: 'Vários idiomas',
    ko: '다국어 지원',
    it: 'Multilingua',
    kk: 'Көптілділік',
  },
  'features.locale.text': {
    en: 'Work in the language you prefer: multiple locales out of the box.',
    ru: 'Работай на удобном языке: несколько локалей из коробки.',
    zh: '用你习惯的语言工作，多种本地化开箱即用。',
    es: 'Trabaja en el idioma que prefieras: varios idiomas listos para usar.',
    de: 'Arbeite in deiner bevorzugten Sprache: mehrere Sprachen direkt verfügbar.',
    fr: 'Travaillez dans la langue qui vous convient : plusieurs langues prêtes à l’emploi.',
    ja: '好きな言語で使える。複数ロケールを標準サポート。',
    hi: 'जिस भाषा में आराम हो उसमें काम करें, कई लोकैल पहले से मौजूद।',
    pt: 'Trabalhe no idioma que preferir: várias localidades prontas para uso.',
    ko: '편한 언어로 작업하세요. 여러 로케일을 기본으로 제공합니다.',
    it: 'Lavora nella lingua che preferisci: più locali già pronti.',
    kk: 'Өзіңізге ыңғайлы тілде жұмыс істеңіз: бірнеше локаль дайын тұр.',
  },

  // ===== WORKFLOW =====
  'workflow.title': {
    en: 'Your day with Plannely',
    ru: 'Твой день с Plannely',
    zh: '你的一天，用 Plannely',
    es: 'Tu día con Plannely',
    de: 'Dein Tag mit Plannely',
    fr: 'Votre journée avec Plannely',
    ja: 'Plannely と過ごす1日',
    hi: 'Plannely के साथ आपका दिन',
    pt: 'Seu dia com o Plannely',
    ko: 'Plannely와 함께하는 하루',
    it: 'La tua giornata con Plannely',
    kk: 'Plannely-мен бір күніңіз',
  },
  'workflow.subtitle': {
    en: 'Three steps from chaos to a predictable day.',
    ru: 'Три шага от хаоса к предсказуемому дню.',
    zh: '三步，从混乱到有序的一天。',
    es: 'Tres pasos del caos a un día predecible.',
    de: 'Drei Schritte vom Chaos zum planbaren Tag.',
    fr: 'Trois étapes pour passer du chaos à une journée maîtrisée.',
    ja: 'カオスな毎日から、予測できる1日へ。たった3ステップ。',
    hi: 'तीन स्टेप — अव्यवस्था से प्रेडिक्टेबल दिन तक।',
    pt: 'Três passos do caos para um dia previsível.',
    ko: '혼란에서 예측 가능한 하루로, 세 단계면 충분합니다.',
    it: 'Tre passi dal caos a una giornata prevedibile.',
    kk: 'Хаостан болжамды күнге дейін үш қадам.',
  },

  'workflow.step1.title': {
    en: 'Capture everything',
    ru: 'Собери задачи',
    zh: '先把一切记录下来',
    es: 'Captura todo',
    de: 'Alles erfassen',
    fr: 'Capturez tout',
    ja: 'まず全部書き出す',
    hi: 'सब कैप्चर करो',
    pt: 'Capture tudo',
    ko: '모두 기록하기',
    it: 'Cattura tutto',
    kk: 'Барлығын жазып ал',
  },
  'workflow.step1.text': {
    en: 'Dump all tasks, ideas and reminders into inbox — nothing gets lost.',
    ru: 'Скинь всё в инбокс — задачи, идеи, напоминания. Ничего не потеряется.',
    zh: '把所有任务、想法和提醒都丢进收件箱，不再丢失。',
    es: 'Vuelca todas las tareas, ideas y recordatorios en la bandeja de entrada: nada se pierde.',
    de: 'Wirf alle Aufgaben, Ideen und Erinnerungen in den Eingang – nichts geht verloren.',
    fr: 'Déposez toutes vos tâches, idées et rappels dans l’inbox — rien ne se perd.',
    ja: 'タスク・アイデア・リマインダーを全部インボックスへ。もうなくならない。',
    hi: 'सारी टास्क, आइडिया, रिमाइंडर इनबॉक्स में डाल दो — कुछ नहीं खोएगा।',
    pt: 'Jogue todas as tarefas, ideias e lembretes na inbox — nada se perde.',
    ko: '작업, 아이디어, 알림을 모두 인박스에 쏟아 넣으세요 — 아무것도 잃어버리지 않습니다.',
    it: 'Butta tutte le attività, idee e promemoria nella inbox — nulla si perde.',
    kk: 'Барлық тапсырмалар мен идеяларды, еске салғыштарды inbox-қа таста — ештеңе жоғалмайды.',
  },

  'workflow.step2.title': {
    en: 'Prioritize',
    ru: 'Расставь приоритеты',
    zh: '设定优先级',
    es: 'Prioriza',
    de: 'Priorisieren',
    fr: 'Priorisez',
    ja: '優先順位をつける',
    hi: 'प्राथमिकता तय करो',
    pt: 'Defina prioridades',
    ko: '우선순위 정하기',
    it: 'Dai priorità',
    kk: 'Басымдық бер',
  },
  'workflow.step2.text': {
    en: 'Distribute by days, set time and repeats. The app will show where you’re overloaded.',
    ru: 'Разбей по дням, задай время и повторения. Приложение подскажет, где перегруз.',
    zh: '按天分配，设定时间和重复频率，应用会提示你哪里超载。',
    es: 'Distribuye por días, fija horas y repeticiones. La app te muestra dónde estás saturado.',
    de: 'Verteile auf Tage, setze Zeiten und Wiederholungen. Die App zeigt dir Überlastungen.',
    fr: 'Répartissez par jours, définissez heures et répétitions. L’app vous signale les surcharges.',
    ja: '日ごとに分けて時間と繰り返しを設定。どこがパンパンかアプリが教えてくれる。',
    hi: 'दिनों में बाँटो, समय और रिपीट सेट करो। ऐप बताएगी कहाँ ओवरलोड हो।',
    pt: 'Distribua por dias, defina horário e repetições. O app mostra onde há sobrecarga.',
    ko: '날짜별로 나누고 시간과 반복을 설정하세요. 앱이 어디가 과부하인지 보여줍니다.',
    it: 'Distribuisci per giorni, imposta orari e ripetizioni. L’app ti mostra dove sei sovraccarico.',
    kk: 'Күндер бойынша бөл, уақыт пен қайталауды орнат. Қай жерде жүктеме жоғары екенін қосымша көрсетеді.',
  },

  'workflow.step3.title': {
    en: 'Follow the plan',
    ru: 'Двигайся по плану',
    zh: '照着计划行动',
    es: 'Sigue el plan',
    de: 'Dem Plan folgen',
    fr: 'Suivez le plan',
    ja: 'プラン通りに進める',
    hi: 'प्लान के हिसाब से चलो',
    pt: 'Siga o plano',
    ko: '계획 따라가기',
    it: 'Segui il piano',
    kk: 'Жоспармен жүр',
  },
  'workflow.step3.text': {
    en: 'Get reminders, mark done and see your progress by day, week and year.',
    ru: 'Получай напоминания, отмечай выполненное и смотри прогресс по дню, неделе и году.',
    zh: '按日、周、年查看进度，收到提醒并标记完成。',
    es: 'Recibe recordatorios, marca como hecho y mira tu progreso por día, semana y año.',
    de: 'Erhalte Erinnerungen, hake Aufgaben ab und sieh deinen Fortschritt nach Tag, Woche und Jahr.',
    fr: 'Recevez des rappels, cochez vos tâches et suivez vos progrès par jour, semaine et année.',
    ja: 'リマインダーを受け取り、完了チェック。日・週・年ごとの進捗が見える。',
    hi: 'रिमाइंडर लो, पूरा होने पर टिक करो और दिन/हफ़्ते/साल के हिसाब से प्रोग्रेस देखो।',
    pt: 'Receba lembretes, marque como concluído e veja seu progresso por dia, semana e ano.',
    ko: '알림을 받고 완료 표시를 하며, 하루·주·연 단위 진행 상황을 확인하세요.',
    it: 'Ricevi promemoria, segna come fatto e osserva i progressi per giorno, settimana e anno.',
    kk: 'Еске салғыштарды ал, орындалғанын белгіле және прогресіңді күн, апта, жыл бойынша бақыла.',
  },

  // ===== PRICING =====
  'pricing.title': {
    en: 'Transparent pricing',
    ru: 'Прозрачные тарифы',
    zh: '透明定价',
    es: 'Precios transparentes',
    de: 'Transparente Preise',
    fr: 'Tarification transparente',
    ja: '分かりやすい料金',
    hi: 'पारदर्शी प्राइसिंग',
    pt: 'Preços transparentes',
    ko: '투명한 요금제',
    it: 'Prezzi trasparenti',
    kk: 'Мөлдір тарифтер',
  },

  'footer.about': {
    en: 'About the Company',
    ru: 'О компании',
    zh: '关于公司',
    es: 'Sobre la empresa',
    de: 'Über das Unternehmen',
    fr: "À propos de l’entreprise",
    ja: '会社情報',
    hi: 'कंपनी के बारे में',
    pt: 'Sobre a empresa',
    ko: '회사 소개',
    it: "Informazioni sull'azienda",
    kk: 'Компания туралы',
  },



  'pricing.subtitle': {
    en: 'Start free and upgrade only if you really need more.',
    ru: 'Начни бесплатно, а затем реши — нужно ли больше.',
    zh: '从免费开始，只有在需要时再升级。',
    es: 'Empieza gratis y solo mejora si realmente necesitas más.',
    de: 'Starte kostenlos und upgrade nur, wenn du wirklich mehr brauchst.',
    fr: 'Commencez gratuitement et passez à la version supérieure uniquement si nécessaire.',
    ja: 'まずは無料で。必要になったらアップグレード。',
    hi: 'फ्री से शुरू करें और सिर्फ ज़रूरत हो तो अपग्रेड करें।',
    pt: 'Comece grátis e faça upgrade só se realmente precisar de mais.',
    ko: '무료로 시작하고, 진짜 더 필요할 때만 업그레이드하세요.',
    it: 'Inizia gratis e passa a un piano superiore solo se ti serve davvero di più.',
    kk: 'Алдымен тегін бастаңыз, шынымен көбірек қажет болса ғана кеңейтіңіз.',
  },

  'pricing.free.title': {
    en: 'Free',
    ru: 'Free',
    zh: '免费版',
    es: 'Free',
    de: 'Free',
    fr: 'Free',
    ja: 'フリー',
    hi: 'फ्री',
    pt: 'Free',
    ko: 'Free',
    it: 'Free',
    kk: 'Free',
  },
  'pricing.free.price': {
    en: '0 / month',
    ru: '0 / месяц',
    zh: '0 / 月',
    es: '0 / mes',
    de: '0 / Monat',
    fr: '0 / mois',
    ja: '0 / 月',
    hi: '0 / महीना',
    pt: '0 / mês',
    ko: '0 / 월',
    it: '0 / mese',
    kk: '0 / ай',
  },
  'pricing.free.feature1': {
    en: 'Unlimited tasks',
    ru: 'Неограниченные задачи',
    zh: '不限数量的任务',
    es: 'Tareas ilimitadas',
    de: 'Unbegrenzte Aufgaben',
    fr: 'Tâches illimitées',
    ja: '無制限のタスク',
    hi: 'अनलिमिटेड टास्क',
    pt: 'Tarefas ilimitadas',
    ko: '무제한 작업',
    it: 'Attività illimitate',
    kk: 'Шексіз тапсырмалар',
  },
  'pricing.free.feature2': {
    en: 'Basic reminders',
    ru: 'Базовые напоминания',
    zh: '基础提醒',
    es: 'Recordatorios básicos',
    de: 'Einfache Erinnerungen',
    fr: 'Rappels de base',
    ja: '基本的なリマインダー',
    hi: 'बेसिक रिमाइंडर',
    pt: 'Lembretes básicos',
    ko: '기본 알림',
    it: 'Promemoria di base',
    kk: 'Негізгі еске салғыштар',
  },
  'pricing.free.feature3': {
    en: 'Daily list & calendar',
    ru: 'Дневной список и календарь',
    zh: '每日清单与日历',
    es: 'Lista diaria y calendario',
    de: 'Tagesliste & Kalender',
    fr: 'Liste du jour et calendrier',
    ja: 'デイリーレストとカレンダー',
    hi: 'डेली लिस्ट और कैलेंडर',
    pt: 'Lista diária e calendário',
    ko: '할 일 목록과 캘린더',
    it: 'Lista giornaliera e calendario',
    kk: 'Күндік тізім мен күнтізбе',
  },
  'pricing.free.cta': {
    en: 'Start for free',
    ru: 'Начать бесплатно',
    zh: '免费开始',
    es: 'Empezar gratis',
    de: 'Kostenlos starten',
    fr: 'Commencer gratuitement',
    ja: '無料で始める',
    hi: 'फ्री में शुरू करें',
    pt: 'Começar grátis',
    ko: '무료로 시작하기',
    it: 'Inizia gratis',
    kk: 'Тегін бастау',
  },

  'pricing.pro.title': {
    en: 'Pro',
    ru: 'Pro',
    zh: '专业版',
    es: 'Pro',
    de: 'Pro',
    fr: 'Pro',
    ja: 'Pro',
    hi: 'Pro',
    pt: 'Pro',
    ko: 'Pro',
    it: 'Pro',
    kk: 'Pro',
  },
  'pricing.pro.price': {
    en: '9.90 / month',
    ru: '990 / месяц',
    zh: '9.90 / 月',
    es: '9,90 / mes',
    de: '9,90 / Monat',
    fr: '9,90 / mois',
    ja: '9.90 / 月',
    hi: '9.90 / महीना',
    pt: '9,90 / mês',
    ko: '월 9.90',
    it: '9,90 / mese',
    kk: '9.90 / ай',
  },
  'pricing.pro.feature1': {
    en: 'Advanced reminders & repeats',
    ru: 'Расширенные напоминания и повторы',
    zh: '高级提醒与重复',
    es: 'Recordatorios avanzados y repeticiones',
    de: 'Erweiterte Erinnerungen & Wiederholungen',
    fr: 'Rappels et répétitions avancés',
    ja: '高度なリマインダーと繰り返し',
    hi: 'एडवांस रिमाइंडर और रिपीट',
    pt: 'Lembretes e repetições avançados',
    ko: '고급 알림 및 반복',
    it: 'Promemoria avanzati e ripetizioni',
    kk: 'Кеңейтілген еске салғыштар мен қайталаулар',
  },
  'pricing.pro.feature2': {
    en: 'Stats, habits and focus mode',
    ru: 'Статистика, привычки и фокус-режим',
    zh: '统计、习惯和专注模式',
    es: 'Estadísticas, hábitos y modo foco',
    de: 'Statistiken, Gewohnheiten & Fokusmodus',
    fr: 'Statistiques, habitudes et mode focus',
    ja: '統計・習慣・フォーカスモード',
    hi: 'स्टैट्स, हैबिट्स और फोकस मोड',
    pt: 'Estatísticas, hábitos e modo foco',
    ko: '통계, 습관, 포커스 모드',
    it: 'Statistiche, abitudini e modalità focus',
    kk: 'Статистика, әдеттер және фокус режимі',
  },
  'pricing.pro.feature3': {
    en: 'Sync across devices',
    ru: 'Синхронизация между устройствами',
    zh: '多设备同步',
    es: 'Sincronización entre dispositivos',
    de: 'Synchronisation über Geräte hinweg',
    fr: 'Synchronisation entre appareils',
    ja: 'デバイス間同期',
    hi: 'डिवाइसेज़ के बीच सिंक',
    pt: 'Sincronização entre dispositivos',
    ko: '기기 간 동기화',
    it: 'Sincronizzazione tra dispositivi',
    kk: 'Құрылғылар арасында синхрондау',
  },
  'pricing.pro.cta': {
    en: 'Upgrade to Pro',
    ru: 'Перейти на Pro',
    zh: '升级到 Pro',
    es: 'Pasar a Pro',
    de: 'Auf Pro upgraden',
    fr: 'Passer à Pro',
    ja: 'Pro にアップグレード',
    hi: 'Pro में अपग्रेड करें',
    pt: 'Fazer upgrade para Pro',
    ko: 'Pro로 업그레이드',
    it: 'Passa a Pro',
    kk: 'Pro-ға өту',
  },

  'pricing.team.title': {
    en: 'Team',
    ru: 'Team',
    zh: '团队版',
    es: 'Team',
    de: 'Team',
    fr: 'Team',
    ja: 'Team',
    hi: 'Team',
    pt: 'Team',
    ko: 'Team',
    it: 'Team',
    kk: 'Team',
  },
  'pricing.team.price': {
    en: 'on request',
    ru: 'по запросу',
    zh: '价格面议',
    es: 'a consultar',
    de: 'auf Anfrage',
    fr: 'sur demande',
    ja: 'お問い合わせ',
    hi: 'अनुरोध पर',
    pt: 'sob consulta',
    ko: '문의 시 안내',
    it: 'su richiesta',
    kk: 'сұраныс бойынша',
  },
  'pricing.team.feature1': {
    en: 'Shared projects & lists',
    ru: 'Совместные проекты и списки',
    zh: '共享项目与列表',
    es: 'Proyectos y listas compartidas',
    de: 'Gemeinsame Projekte & Listen',
    fr: 'Projets et listes partagés',
    ja: '共有プロジェクトとリスト',
    hi: 'शेयर प्रोजेक्ट और लिस्ट',
    pt: 'Projetos e listas compartilhados',
    ko: '공유 프로젝트 및 목록',
    it: 'Progetti e liste condivisi',
    kk: 'Ортақ жобалар мен тізімдер',
  },
  'pricing.team.feature2': {
    en: 'Team calendar',
    ru: 'Общий календарь команды',
    zh: '团队日历',
    es: 'Calendario de equipo',
    de: 'Teamkalender',
    fr: 'Calendrier d’équipe',
    ja: 'チームカレンダー',
    hi: 'टीम कैलेंडर',
    pt: 'Calendário da equipe',
    ko: '팀 캘린더',
    it: 'Calendario del team',
    kk: 'Команда күнтізбесі',
  },
  'pricing.team.feature3': {
    en: 'Priority support',
    ru: 'Приоритетная поддержка',
    zh: '优先支持',
    es: 'Soporte prioritario',
    de: 'Priorisierter Support',
    fr: 'Support prioritaire',
    ja: '優先サポート',
    hi: 'प्रायोरिटी सपोर्ट',
    pt: 'Suporte prioritário',
    ko: '우선 지원',
    it: 'Supporto prioritario',
    kk: 'Басымдық берілген қолдау',
  },
  'pricing.team.cta': {
    en: 'Contact us',
    ru: 'Связаться с нами',
    zh: '联系我们',
    es: 'Contactar',
    de: 'Kontakt aufnehmen',
    fr: 'Nous contacter',
    ja: 'お問い合わせ',
    hi: 'हमसे संपर्क करें',
    pt: 'Fale com a gente',
    ko: '문의하기',
    it: 'Contattaci',
    kk: 'Бізге жазу',
  },

  'pricing.badge.popular': {
    en: 'Most popular',
    ru: 'Популярный',
    zh: '最受欢迎',
    es: 'Más popular',
    de: 'Am beliebtesten',
    fr: 'Le plus populaire',
    ja: '一番人気',
    hi: 'सबसे लोकप्रिय',
    pt: 'Mais popular',
    ko: '가장 인기',
    it: 'Più scelto',
    kk: 'Ең танымал',
  },

  // ===== FAQ =====
  'faq.title': {
    en: 'Frequently asked questions',
    ru: 'Ответы на частые вопросы',
    zh: '常见问题',
    es: 'Preguntas frecuentes',
    de: 'Häufige Fragen',
    fr: 'Questions fréquentes',
    ja: 'よくある質問',
    hi: 'अक्सर पूछे जाने वाले प्रश्न',
    pt: 'Perguntas frequentes',
    ko: '자주 묻는 질문',
    it: 'Domande frequenti',
    kk: 'Жиі қойылатын сұрақтар',
  },
  'faq.subtitle': {
    en: 'Still not sure? Ask us anything.',
    ru: 'Если что-то ещё непонятно — напиши нам.',
    zh: '还有疑问？随时问我们。',
    es: '¿Aún con dudas? Pregúntanos lo que quieras.',
    de: 'Noch unsicher? Frag uns einfach.',
    fr: 'Encore des doutes ? Posez-nous vos questions.',
    ja: 'まだ不安ですか？何でも聞いてください。',
    hi: 'अब भी कन्फ्यूज़ हैं? जो भी पूछना हो, पूछें।',
    pt: 'Ainda em dúvida? Pergunte qualquer coisa.',
    ko: '아직 고민되나요? 무엇이든 물어보세요.',
    it: 'Non sei ancora sicuro? Chiedici qualsiasi cosa.',
    kk: 'Әлі де күмән бар ма? Қалағаныңызды сұраңыз.',
  },

  'faq.q1.title': {
    en: 'Is the app really free?',
    ru: 'Приложение точно бесплатно?',
    zh: '应用真的永久免费吗？',
    es: '¿La app es realmente gratis?',
    de: 'Ist die App wirklich kostenlos?',
    fr: "L’app est-elle vraiment gratuite ?",
    ja: 'このアプリは本当に無料ですか？',
    hi: 'क्या ऐप सच में फ्री है?',
    pt: 'O app é realmente gratuito?',
    ko: '앱이 정말 무료인가요?',
    it: "L'app è davvero gratuita?",
    kk: 'Қосымша шынымен тегін бе?',
  },
  'faq.q1.text': {
    en: 'Yes, the Free plan stays free forever. Pro unlocks advanced features, but you can live comfortably on Free.',
    ru: 'Да, базовый тариф Free остаётся бесплатным навсегда. Pro открывает продвинутые функции, но можно спокойно жить и на Free.',
    zh: '是的，免费方案会一直免费。Pro 解锁高级功能，但用免费版也可以舒适使用。',
    es: 'Sí, el plan Free es gratis para siempre. Pro desbloquea funciones avanzadas, pero puedes vivir bien con Free.',
    de: 'Ja, der Free-Tarif bleibt dauerhaft kostenlos. Pro schaltet zusätzliche Funktionen frei, aber Free reicht vielen völlig aus.',
    fr: 'Oui, l’offre Free reste gratuite pour toujours. Pro débloque des fonctions avancées, mais on peut très bien rester sur Free.',
    ja: 'はい、Free プランはずっと無料です。Pro で高度な機能が使えますが、Free だけでも十分使えます。',
    hi: 'हाँ, Free प्लान हमेशा फ्री रहेगा। Pro में एडवांस फ़ीचर्स हैं, लेकिन आप आराम से Free पर रह सकते हैं।',
    pt: 'Sim, o plano Free continua gratuito para sempre. O Pro libera recursos avançados, mas é possível viver muito bem só com o Free.',
    ko: '네, Free 요금제는 영원히 무료입니다. Pro에서 고급 기능이 열리지만, Free만으로도 충분히 쓸 수 있습니다.',
    it: 'Sì, il piano Free rimane gratuito per sempre. Pro sblocca funzioni avanzate, ma puoi vivere tranquillamente anche solo con Free.',
    kk: 'Иә, Free тарифі әрқашан тегін қалады. Pro-да кеңейтілген функциялар ашылады, бірақ тек Free-мен де жайлы қолдануға болады.',
  },

  'faq.q2.title': {
    en: 'Will reminders work offline?',
    ru: 'Будут ли работать напоминания, если интернет пропадёт?',
    zh: '离线时提醒还能正常吗？',
    es: '¿Los recordatorios funcionan sin conexión?',
    de: 'Funktionieren Erinnerungen auch offline?',
    fr: 'Les rappels fonctionnent-ils hors ligne ?',
    ja: 'オフラインでもリマインダーは動きますか？',
    hi: 'क्या बिना इंटरनेट के भी रिमाइंडर चलेंगे?',
    pt: 'Os lembretes funcionam offline?',
    ko: '오프라인에서도 알림이 오나요?',
    it: 'I promemoria funzionano anche offline?',
    kk: 'Интернет болмаса, еске салғыштар жұмыс істей ме?',
  },
  'faq.q2.text': {
    en: 'Yes, scheduled reminders work offline — they are stored on the device and fire on time.',
    ru: 'Да, запланированные напоминания приходят офлайн: они сохраняются на устройстве и срабатывают по расписанию.',
    zh: '是的，已安排的提醒会离线运行：保存在设备本地，按时触发。',
    es: 'Sí, los recordatorios programados funcionan sin conexión: se almacenan en el dispositivo y se disparan a su hora.',
    de: 'Ja, geplante Erinnerungen funktionieren offline. Sie werden lokal gespeichert und rechtzeitig ausgelöst.',
    fr: 'Oui, les rappels programmés fonctionnent hors ligne : ils sont stockés sur l’appareil et se déclenchent à l’heure prévue.',
    ja: 'はい。予定済みリマインダーは端末に保存され、オフラインでも時間通りに鳴ります。',
    hi: 'हाँ, शेड्यूल्ड रिमाइंडर ऑफ़लाइन भी काम करते हैं — ये डिवाइस पर सेव रहते हैं और टाइम पर फायर होते हैं।',
    pt: 'Sim, lembretes agendados funcionam offline — eles ficam no dispositivo e disparam na hora certa.',
    ko: '네, 예약된 알림은 오프라인에서도 작동합니다. 기기에 저장되었다가 제시간에 울립니다.',
    it: 'Sì, i promemoria pianificati funzionano offline — sono salvati sul dispositivo e scattano all’ora giusta.',
    kk: 'Иә, жоспарланған еске салғыштар офлайн да жұмыс істейді — олар құрылғыда сақталып, уақытында шығады.',
  },

  'faq.q3.title': {
    en: 'Can I import tasks from another TODO app?',
    ru: 'Можно ли перенести задачи из другого TODO-сервиса?',
    zh: '可以从其它待办应用导入任务吗？',
    es: '¿Puedo importar tareas desde otra app de tareas?',
    de: 'Kann ich Aufgaben aus einer anderen To-do-App importieren?',
    fr: 'Puis-je importer des tâches depuis une autre app TODO ?',
    ja: '他のTODOアプリからタスクをインポートできますか？',
    hi: 'क्या मैं दूसरी TODO ऐप से टास्क इम्पोर्ट कर सकता हूँ?',
    pt: 'Posso importar tarefas de outro app de TODO?',
    ko: '다른 TODO 앱에서 작업을 가져올 수 있나요?',
    it: 'Posso importare attività da un’altra app TODO?',
    kk: 'Басқа TODO-қызметтен тапсырмаларды импорттай аламын ба?',
  },
  'faq.q3.text': {
    en: 'We plan imports from popular apps. For now you can quickly copy lists manually.',
    ru: 'Мы планируем импорт из популярных приложений. Пока задачи можно быстро перенести вручную через списки.',
    zh: '我们计划支持主流应用的导入。目前可以先通过复制列表的方式快速迁移。',
    es: 'Planeamos importar desde apps populares. Por ahora puedes copiar tus listas manualmente.',
    de: 'Importe aus beliebten Apps sind geplant. Bis dahin kannst du deine Listen schnell manuell übernehmen.',
    fr: 'Nous prévoyons l’import depuis les apps populaires. Pour l’instant, vous pouvez copier vos listes manuellement.',
    ja: '人気アプリからのインポートを予定しています。今はリストを手動でコピーして素早く移行できます。',
    hi: 'हम पॉपुलर ऐप्स से इम्पोर्ट जोड़ने की योजना में हैं। अभी के लिए आप लिस्ट कॉपी करके जल्दी माइग्रेट कर सकते हैं।',
    pt: 'Planejamos importações de apps populares. Por enquanto você pode copiar suas listas rapidamente de forma manual.',
    ko: '주요 앱에서 가져오기 기능을 준비 중입니다. 지금은 목록을 빠르게 복사해서 옮길 수 있습니다.',
    it: 'Abbiamo in programma importazioni dalle app più popolari. Per ora puoi copiare rapidamente le liste a mano.',
    kk: 'Танымал қосымшалардан импорттауды жоспарлап жатырмыз. Әзірге тізімдерді қолмен жылдам көшіруге болады.',
  },

  // ===== FOOTER =====
  'footer.tagline': {
    en: 'Less chaos — more results.',
    ru: 'Меньше хаоса — больше результата.',
    zh: '更少混乱，更多成果。',
    es: 'Menos caos, más resultados.',
    de: 'Weniger Chaos — mehr Resultate.',
    fr: 'Moins de chaos — plus de résultats.',
    ja: '混乱を減らして、成果を増やそう。',
    hi: 'कम अव्यवस्था — ज़्यादा नतीजे。',
    pt: 'Menos caos — mais resultados.',
    ko: '혼란은 줄이고, 결과는 더 많이.',
    it: 'Meno caos — più risultati.',
    kk: 'Аз хаос — көп нәтиже.',
  },
  'footer.privacy': {
    en: 'Privacy policy',
    ru: 'Политика конфиденциальности',
    zh: '隐私政策',
    es: 'Política de privacidad',
    de: 'Datenschutzerklärung',
    fr: 'Politique de confidentialité',
    ja: 'プライバシーポリシー',
    hi: 'प्राइवेसी पॉलिसी',
    pt: 'Política de privacidade',
    ko: '개인정보 처리방침',
    it: 'Informativa sulla privacy',
    kk: 'Құпиялылық саясаты',
  },
  'footer.support': {
    en: 'Support',
    ru: 'Поддержка',
    zh: '支持',
    es: 'Soporte',
    de: 'Support',
    fr: 'Assistance',
    ja: 'サポート',
    hi: 'सहायता',
    pt: 'Suporte',
    ko: '지원',
    it: 'Assistenza',
    kk: 'Қолдау',
  },
  'footer.terms': {
    en: 'Terms of use',
    ru: 'Условия использования',
    zh: '使用条款',
    es: 'Términos de uso',
    de: 'Nutzungsbedingungen',
    fr: "Conditions d'utilisation",
    ja: '利用規約',
    hi: 'उपयोग की शर्तें',
    pt: 'Termos de uso',
    ko: '이용 약관',
    it: 'Termini d’uso',
    kk: 'Пайдалану шарттары',
  },

    // ===== PLATFORMS =====
  'platforms.title': {
    en: 'Available on your devices',
    ru: 'Платформы',
    zh: '支持的平台',
    es: 'Plataformas',
    de: 'Plattformen',
    fr: 'Plateformes',
    ja: '対応プラットフォーム',
    hi: 'प्लेटफ़ॉर्म',
    pt: 'Plataformas',
    ko: '지원 플랫폼',
    it: 'Piattaforme',
    kk: 'Платформалар',
  },
  'platforms.subtitle': {
    en: 'Download Plannely on your favorite platforms. If a store is not ready yet, you’ll see “Coming soon”.',
    ru: 'Скачайте Plannely на любимых платформах. Если площадка ещё не готова, вы увидите пометку «Скоро».',
    zh: '在你常用的平台上下载 Plannely。尚未上线的商店会显示“即将推出”。',
    es: 'Descarga Plannely en tus plataformas favoritas. Si una tienda aún no está lista verás “Próximamente”.',
    de: 'Lade Plannely auf deinen Lieblingsplattformen. Wenn ein Store noch nicht bereit ist, siehst du „Bald verfügbar“.',
    fr: 'Téléchargez Plannely sur vos plateformes préférées. Si une boutique n’est pas encore prête, vous verrez « Bientôt ».',
    ja: 'よく使うプラットフォームで Plannely を利用できます。まだ公開前のストアには「近日リリース」と表示されます。',
    hi: 'अपनी पसंद की प्लेटफ़ॉर्म पर Plannely डाउनलोड करें। जो स्टोर अभी तैयार नहीं हैं वहाँ “जल्द ही” दिखेगा।',
    pt: 'Baixe o Plannely nas suas plataformas favoritas. Quando uma loja ainda não estiver pronta, você verá “Em breve”.',
    ko: '즐겨 사용하는 플랫폼에서 Plannely를 사용할 수 있습니다. 아직 준비되지 않은 스토어에는 “곧 제공 예정”이라고 표시됩니다.',
    it: 'Scarica Plannely sulle tue piattaforme preferite. Se uno store non è ancora pronto vedrai “Presto disponibile”.',
    kk: 'Plannely-ді өзіңіз қолданатын платформаларға жүктеңіз. Егер дүкен әлі дайын болмаса, «Жақында» деген жазу шығады.',
  },

  // Android
  'platforms.android.name': {
    en: 'Android',
    ru: 'Android',
    zh: 'Android',
    es: 'Android',
    de: 'Android',
    fr: 'Android',
    ja: 'Android',
    hi: 'Android',
    pt: 'Android',
    ko: 'Android',
    it: 'Android',
    kk: 'Android',
  },
  'platforms.android.caption': {
    en: 'Phones and tablets via Google Play.',
    ru: 'Смартфоны и планшеты через Google Play.',
    zh: '通过 Google Play 安装到手机和平板。',
    es: 'Teléfonos y tablets vía Google Play.',
    de: 'Smartphones und Tablets über Google Play.',
    fr: 'Smartphones et tablettes via Google Play.',
    ja: 'Google Play からスマホとタブレットにインストール。',
    hi: 'Google Play के ज़रिए फ़ोन और टैबलेट।',
    pt: 'Celulares e tablets via Google Play.',
    ko: 'Google Play를 통해 휴대폰과 태블릿에 설치.',
    it: 'Smartphone e tablet tramite Google Play.',
    kk: 'Смартфондар мен планшеттер Google Play арқылы.',
  },
  'platforms.android.cta': {
    en: 'Open in Google Play',
    ru: 'Открыть в Google Play',
    zh: '在 Google Play 打开',
    es: 'Abrir en Google Play',
    de: 'In Google Play öffnen',
    fr: 'Ouvrir dans Google Play',
    ja: 'Google Play を開く',
    hi: 'Google Play पर खोलें',
    pt: 'Abrir no Google Play',
    ko: 'Google Play에서 열기',
    it: 'Apri in Google Play',
    kk: 'Google Play ішінде ашу',
  },
  'platforms.android.soon': {
    en: 'Coming soon on Google Play',
    ru: 'Скоро в Google Play',
    zh: '即将在 Google Play 上线',
    es: 'Próximamente en Google Play',
    de: 'Bald bei Google Play',
    fr: 'Bientôt sur Google Play',
    ja: '近日 Google Play に登場',
    hi: 'जल्द ही Google Play पर',
    pt: 'Em breve no Google Play',
    ko: '곧 Google Play 출시',
    it: 'Presto su Google Play',
    kk: 'Жақында Google Play-де',
  },

  // iOS / App Store
  'platforms.ios.name': {
    en: 'macOS, iOS & iPadOS',
    ru: 'macOS, iOS и iPadOS',
    zh: 'macOS, iOS 与 iPadOS',
    es: 'macOS, iOS y iPadOS',
    de: 'macOS, iOS & iPadOS',
    fr: 'macOS, iOS et iPadOS',
    ja: 'macOS, iOS / iPadOS',
    hi: 'macOS, iOS और iPadOS',
    pt: 'macOS, iOS e iPadOS',
    ko: 'macOS, iOS & iPadOS',
    it: 'macOS, iOS e iPadOS',
    kk: 'macOS, iOS және iPadOS',
  },
  'platforms.ios.caption': {
    en: 'iPhone and iPad via App Store.',
    ru: 'iPhone и iPad через App Store.',
    zh: '在 App Store 获取 iPhone 和 iPad 版本。',
    es: 'iPhone y iPad desde App Store.',
    de: 'iPhone und iPad über den App Store.',
    fr: 'iPhone et iPad via l’App Store.',
    ja: 'App Store から iPhone / iPad 版。',
    hi: 'App Store से iPhone और iPad पर।',
    pt: 'iPhone e iPad pela App Store.',
    ko: 'App Store에서 iPhone과 iPad용 앱.',
    it: 'iPhone e iPad tramite App Store.',
    kk: 'iPhone және iPad үшін App Store арқылы.',
  },
  'platforms.ios.cta': {
    en: 'Open in the App Store',
    ru: 'Открыть в App Store',
    zh: '在 App Store 打开',
    es: 'Abrir en App Store',
    de: 'Im App Store öffnen',
    fr: 'Ouvrir dans l’App Store',
    ja: 'App Store を開く',
    hi: 'App Store पर खोलें',
    pt: 'Abrir na App Store',
    ko: 'App Store에서 열기',
    it: 'Apri in App Store',
    kk: 'App Store ішінде ашу',
  },
  'platforms.ios.soon': {
    en: 'Coming soon on the App Store',
    ru: 'Скоро в App Store',
    zh: '即将在 App Store 上线',
    es: 'Próximamente en App Store',
    de: 'Bald im App Store',
    fr: 'Bientôt sur l’App Store',
    ja: '近日 App Store に登場',
    hi: 'जल्द ही App Store पर',
    pt: 'Em breve na App Store',
    ko: '곧 App Store 출시',
    it: 'Presto su App Store',
    kk: 'Жақында App Store-де',
  },

  // Windows
  'platforms.windows.name': {
    en: 'Windows',
    ru: 'Windows',
    zh: 'Windows',
    es: 'Windows',
    de: 'Windows',
    fr: 'Windows',
    ja: 'Windows',
    hi: 'Windows',
    pt: 'Windows',
    ko: 'Windows',
    it: 'Windows',
    kk: 'Windows',
  },
  'platforms.windows.caption': {
    en: 'Desktop app for Windows.',
    ru: 'Настольное приложение для Windows.',
    zh: 'Windows 桌面应用。',
    es: 'Aplicación de escritorio para Windows.',
    de: 'Desktop-App für Windows.',
    fr: 'Application de bureau pour Windows.',
    ja: 'Windows デスクトップアプリ。',
    hi: 'Windows के लिए डेस्कटॉप ऐप।',
    pt: 'Aplicativo desktop para Windows.',
    ko: 'Windows용 데스크톱 앱.',
    it: 'App desktop per Windows.',
    kk: 'Windows үшін үстелдік қосымша.',
  },
  'platforms.windows.cta': {
    en: 'Download for Windows',
    ru: 'Скачать для Windows',
    zh: '下载 Windows 版',
    es: 'Descargar para Windows',
    de: 'Für Windows herunterladen',
    fr: 'Télécharger pour Windows',
    ja: 'Windows 版をダウンロード',
    hi: 'Windows के लिए डाउनलोड करें',
    pt: 'Baixar para Windows',
    ko: 'Windows용 다운로드',
    it: 'Scarica per Windows',
    kk: 'Windows нұсқасын жүктеу',
  },
  'platforms.windows.soon': {
    en: 'Coming soon on Windows',
    ru: 'Скоро на Windows',
    zh: '即将在 Windows 上线',
    es: 'Próximamente en Windows',
    de: 'Bald für Windows verfügbar',
    fr: 'Bientôt sur Windows',
    ja: '近日 Windows 版リリース',
    hi: 'जल्द ही Windows पर',
    pt: 'Em breve no Windows',
    ko: '곧 Windows용 출시',
    it: 'Presto su Windows',
    kk: 'Жақында Windows үшін',
  },

  // macOS
  'platforms.mac.name': {
    en: 'macOS',
    ru: 'macOS',
    zh: 'macOS',
    es: 'macOS',
    de: 'macOS',
    fr: 'macOS',
    ja: 'macOS',
    hi: 'macOS',
    pt: 'macOS',
    ko: 'macOS',
    it: 'macOS',
    kk: 'macOS',
  },
  'platforms.mac.caption': {
    en: 'Desktop app for Mac.',
    ru: 'Настольное приложение для Mac.',
    zh: 'Mac 桌面应用。',
    es: 'Aplicación de escritorio para Mac.',
    de: 'Desktop-App für Mac.',
    fr: 'Application de bureau pour Mac.',
    ja: 'Mac デスクトップアプリ。',
    hi: 'Mac के लिए डेस्कटॉप ऐप।',
    pt: 'Aplicativo desktop para Mac.',
    ko: 'Mac용 데스크톱 앱.',
    it: 'App desktop per Mac.',
    kk: 'Mac үшін үстелдік қосымша.',
  },
  'platforms.mac.cta': {
    en: 'Download for macOS',
    ru: 'Скачать для macOS',
    zh: '下载 macOS 版',
    es: 'Descargar para macOS',
    de: 'Für macOS herunterladen',
    fr: 'Télécharger pour macOS',
    ja: 'macOS 版をダウンロード',
    hi: 'macOS के लिए डाउनलोड करें',
    pt: 'Baixar para macOS',
    ko: 'macOS용 다운로드',
    it: 'Scarica per macOS',
    kk: 'macOS нұсқасын жүктеу',
  },
  'platforms.mac.soon': {
    en: 'Coming soon on macOS',
    ru: 'Скоро на macOS',
    zh: '即将在 macOS 上线',
    es: 'Próximamente en macOS',
    de: 'Bald für macOS verfügbar',
    fr: 'Bientôt sur macOS',
    ja: '近日 macOS 版リリース',
    hi: 'जल्द ही macOS पर',
    pt: 'Em breve no macOS',
    ko: '곧 macOS용 출시',
    it: 'Presto su macOS',
    kk: 'Жақында macOS үшін',
  },

    'nav.platforms': {
    en: 'Platforms',
    ru: 'Платформы',
    zh: '平台',
    es: 'Plataformas',
    de: 'Plattformen',
    fr: 'Plateformes',
    ja: 'プラットフォーム',
    hi: 'प्लेटफ़ॉर्म',
    pt: 'Plataformas',
    ko: '플랫폼',
    it: 'Piattaforme',
    kk: 'Платформалар',
  },


};


export function t(key, lang = defaultLang) {
  const entry = translations[key];
  if (!entry) return key;
  return entry[lang] || entry.en || Object.values(entry)[0] || key;
}
